import { SalesProductType } from './sales-product-type';
import { Currency } from './currency';
import Decimal from 'decimal.js';

export class SalesProduct {

    constructor(
        public productType: SalesProductType,
        public description: string,
        public amount: Decimal,
        public currency: Currency,
        public id?: number,
        public amountInBase?: Decimal | null,
        public amountInSecond?: Decimal
    ){}
}
